import { unwrap } from "@nexxt/api-client";
import { vendorReturnQueries } from "@nexxt/logistics-ui";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// What Backstage alone reads of a vendor return: how the warehouse (I-10) and Business Central (I-25) took it
// (ADR-141), under the keys of @nexxt/logistics-ui, so whatever reloads the returns reloads it too.

const byId = api.logistics["vendor-returns"][":vendorReturnId"];

/** The tabs of the page of a return, in the order it shows them. */
export const vendorReturnTabs = ["lines", "systems", "details"] as const;
export type VendorReturnTab = (typeof vendorReturnTabs)[number];

export const vendorReturnSync = (vendorReturnId: string) =>
  queryOptions({
    queryKey: [...vendorReturnQueries.of(vendorReturnId), "sync"],
    queryFn: ({ signal }) => unwrap(byId.sync.$get({ param: { vendorReturnId } }, { init: { signal } })),
  });
